import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { IconImg } from '../../Defaults/Icon/IconImg';
import { resolveCategoryUrlFromCategory } from '../../../utilities/selectors';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { getImagePath } from '../../../utilities/product';
import { Picture } from '../Picture/Picture';
import { prop } from '../../../utilities';

export enum MenuState {
  CLOSED,
  CATEGORIES_SHOWN,
  FAVOURITES_SHOWN,
}

export interface Props {
  category: any;
  onClick: any;
  navigationType: MenuState;
  byId: any;
}

function CorporateNavigationDropdownItemWindow({
  category,
  onClick,
  navigationType,
  byId,
}: Props) {
  const renderCategories = () => {
    return (
      <>
        <ItemsWrapper>
          {category.children &&
            category.children.map(item => (
              // tslint:disable-next-line:jsx-key
              <WindowRow>
                <ImageLink
                  onClick={onClick}
                  to={resolveCategoryUrlFromCategory(item, byId)}
                >
                  <Picture
                    image={item.image}
                    width={56}
                    height={56}
                    alt={__('Obrázok kategórie')}
                    customStyles={{ width: rem(56) }}
                  />
                  {/* <SubCategoryImg
                    alt={__('Obrázok kategórie')}
                    src={
                      item.image
                        ? getImagePath(
                            item.image,
                            {
                              width: 156,
                              height: 156,
                            },
                            false,
                            false,
                            false,
                          )
                        : '/images/icons/placeholder.svg'
                    }
                  /> */}
                </ImageLink>
                <SubCategoryWrapper>
                  <SubCategoryName
                    noChildren={item.children.length === 0}
                    onClick={onClick}
                    to={resolveCategoryUrlFromCategory(item, byId)}
                  >
                    {prop(item, 'publish.0.content.json_content.shortname') ||
                      prop(item, 'publish.0.category_name') ||
                      item.category_name}
                  </SubCategoryName>
                  <SubCategoryChildren>
                    {item.children.length > 0 &&
                      item.children.map((child, j) => (
                        // tslint:disable-next-line:jsx-key
                        <SubCategoryChild
                          onClick={onClick}
                          to={resolveCategoryUrlFromCategory(child, byId)}
                        >
                          {(prop(
                            child,
                            'publish.0.content.json_content.shortname',
                          ) ||
                            prop(child, 'publish.0.category_name') ||
                            child.category_name) +
                            (j !== item.children.length - 1 ? ', ' : '')}
                        </SubCategoryChild>
                      ))}
                  </SubCategoryChildren>
                </SubCategoryWrapper>
              </WindowRow>
            ))}
        </ItemsWrapper>
        <ImageWrapper
          noWebpUrl={
            category.image
              ? getImagePath(category.image, undefined, true, false, true)
              : '/images/icons/placeholder.svg'
          }
          imageUrl={
            category.image
              ? getImagePath(category.image, undefined, true, true, true)
              : '/images/icons/placeholder.svg'
          }
        />
      </>
    );
  };

  const renderFavourites = () => {
    const categoriesWithImages = category.children.filter(c => c.image);
    const categoriesWithoutImages = category.children.filter(c => !c.image);

    // categoriesWithImages = [...categoriesWithImages, ...categoriesWithImages, ...categoriesWithImages, ...categoriesWithImages, ...categoriesWithImages, ...categoriesWithImages];
    // categoriesWithoutImages = [...categoriesWithoutImages, ...categoriesWithoutImages, ...categoriesWithoutImages]

    return (
      <FavouriteCategoriesWrapper>
        <CategoriesWithoutImage
          hasMarginBottom={categoriesWithImages.length > 0}
        >
          {categoriesWithoutImages &&
            categoriesWithoutImages.map((item, key) => (
              <FavouriteLink
                key={key}
                onClick={onClick}
                to={resolveCategoryUrlFromCategory(item, byId)}
              >
                <FavouriteName>
                  {prop(item, 'publish.0.content.json_content.shortname') ||
                    prop(item, 'publish.0.category_name') ||
                    item.category_name}
                </FavouriteName>
              </FavouriteLink>
            ))}
        </CategoriesWithoutImage>
        <CategoriesWithImage>
          {categoriesWithImages &&
            categoriesWithImages.map((item, key) => (
              <FavouriteLink
                key={key}
                onClick={onClick}
                to={resolveCategoryUrlFromCategory(item, byId)}
              >
                <FavouriteLinkCover
                  noWebpImage={getImagePath(
                    item.image,
                    {
                      width: 700,
                      height: 160,
                    },
                    false,
                    false,
                    true,
                  )}
                  backgroundUrl={getImagePath(
                    item.image,
                    {
                      width: 700,
                      height: 160,
                    },
                    false,
                    true,
                    true,
                  )}
                >
                  <FavouriteName>
                    {prop(item, 'publish.0.content.json_content.shortname') ||
                      prop(item, 'publish.0.category_name') ||
                      item.category_name}
                  </FavouriteName>
                </FavouriteLinkCover>
              </FavouriteLink>
            ))}
        </CategoriesWithImage>
      </FavouriteCategoriesWrapper>
    );
  };

  const isSmall = navigationType === MenuState.FAVOURITES_SHOWN ? true : false;
  return (
    <Wrapper isSmall={isSmall}>
      {navigationType === MenuState.CATEGORIES_SHOWN && renderCategories()}
      {navigationType === MenuState.FAVOURITES_SHOWN && renderFavourites()}
    </Wrapper>
  );
}

const Wrapper = styled.div<{ isSmall: boolean }>`
  width: 100%;
  min-height: ${({ isSmall }) => (isSmall ? rem(350) : rem(440))};
  position: absolute;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.textPrimary};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 0 0 ${rem(4)} ${rem(4)};
  overflow: hidden;

  left: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  justify-content: flex-start;
  align-items: flex-start;

  ${({ theme }) => theme.mediab.l1150`
    display: none;
  `}
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: ${rem(24)} ${rem(30)};
  max-width: calc(100% - 504px);
  width: 100%;

  ${({ theme }) => theme.mediab.l1300`
    max-width: initial;
    width: 100%;
  `}
`;

const ImageWrapper = styled.div<{ imageUrl?: string; noWebpUrl?: string }>`
  width: 100%;
  max-width: ${rem(504)};
  height: ${rem(440)};
  background: center/cover
    url(${props => (props.imageUrl ? `${props.imageUrl}` : '')});
  /* flex: 1 1 50%; */
  position: absolute;
  height: 100%;
  right: 0;
  top: 0;
  bottom: 0;

  .no-webp &&& {
    background: center/cover
      url(${props => (props.noWebpUrl ? `${props.noWebpUrl}` : '')});
  }

  ${({ theme }) => theme.mediab.l1300`
    display: none;
  `}
`;

const WindowRow = styled.div`
  width: 50%;
  padding: ${rem(16)} ${rem(5)};
  display: inline-flex;
  flex-direction: row;
  text-decoration: none;
  align-items: flex-start;
`;

const SubCategoryImg = styled(IconImg)`
  margin-right: ${rem(16)};
  width: ${rem(56)};
  height: ${rem(56)};
  object-fit: cover;
  flex: 0 0 3.5rem;
  cursor: pointer;
`;

const ImageLink = styled(Link)`
  margin-right: ${rem(16)};
`;

const SubCategoryName = styled(Link)<{ noChildren?: boolean }>`
  font-weight: 500;
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  margin-bottom: ${rem(8)};
  margin-top: ${({ noChildren }) => (noChildren ? rem(8) : 0)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const SubCategoryWrapper = styled(FlexCol)`
  max-width: 80%;
`;

const SubCategoryChildren = styled(TextP)`
  margin-bottom: 0;
`;

const SubCategoryChild = styled(Link)`
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const FavouriteCategoriesWrapper = styled.div`
  padding: ${rem(40)};
  width: 100%;
`;

const FavouriteLink = styled(Link)`
  font-weight: 500;
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const FavouriteName = styled.p`
  margin: 0;
  position: relative;
  z-index: 1;
`;

const CategoriesWithoutImage = styled.div<{ hasMarginBottom: boolean }>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${rem(23)};
  margin-bottom: ${({ hasMarginBottom }) => (hasMarginBottom ? rem(40) : 0)};
`;

const CategoriesWithImage = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${rem(16)};
`;

const FavouriteLinkCover = styled.div<{
  backgroundUrl: string;
  noWebpImage: string;
}>`
  background-image: url("${props => props.backgroundUrl}");
  height: 100%;
  min-height: ${rem(80)};
  font-size: ${rem(18)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: flex-start;
  padding: ${rem(5)} ${rem(5)} ${rem(5)} ${rem(24)};
  align-items: center;
  border-radius: ${rem(4)};
  position: relative;
  text-shadow: 0 ${rem(1)} ${rem(2)} #0000008F;
  background-size: cover;
  background-position: center;
  
  &::before {
    content: "";
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    width: ${rem(113)};
    background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(255,255,255,0) 100%);
    border-radius: ${rem(4)};
    opacity: 0.8;
    z-index: 0;
  }

  .no-webp &&& {
    background-image: url("${props => props.noWebpImage}");
  }
`;

export { CorporateNavigationDropdownItemWindow };
